<app-page
  [content]="content"
  [action]="action"
/>

<ng-template #content>
  <h1 class="text-bold m-t-5">Assessments overview</h1>

  <div class="content-layout-column-sm-row-lg">
    <div>
      <!-- NOTE: To be refactored -->
      @if (getTestletList(); as testletList) {
        <div class="mt-5">
          <!-- Progress Bar -->
          <div class="progress-wrapper">
            <div class="mx-md-1 mx-lg-0">
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  [style.width]="calculateProgress()"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <div class="d-flex justify-content-between">
                @for (testlet of testletList; track testlet) {
                  <div>
                    @switch (testlet.progress) {
                      @case (TestProgress.Completed) {
                        <svg-icon
                          src="assets/icons/check.svg"
                          [svgStyle]="{
                            'width.px': 16,
                            'height.px': 16,
                            fill: '#fff',
                          }"
                          class="progress-icon step-icon circle-outline d-flex align-items-center justify-content-center bg-primary-main rounded-circle"
                        ></svg-icon>
                      }
                      @case (TestProgress.Current) {
                        <div
                          class="progress-icon step-icon circle-outline d-flex align-items-center justify-content-center bg-white rounded-circle"
                        >
                          <div class="circle-fill bg-primary-main"></div>
                        </div>
                      }
                      @case (TestProgress.NotCompleted) {
                        <div
                          class="progress-icon step-icon lock-icon d-flex align-items-center justify-content-center rounded-circle"
                        >
                          <svg-icon
                            class="svg-fill"
                            src="assets/icons/lock.svg"
                          >
                          </svg-icon>
                        </div>
                      }
                    }
                    <div
                      class="text-center"
                      [ngClass]="{
                        'fw-bolder': testlet.progress === TestProgress.Current,
                      }"
                    >
                      {{ Number(testlet.key) + 1 }}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <!-- Assessmet Cards -->
          <div class="card-container d-flex flex-wrap justify-content-md-center mt-1 mt-md-2 pt-3 pb-lg-5">
            @for (testlet of testletList; track testlet) {
              <div class="col-4 col-md-auto d-flex justify-content-center px-0">
                <div
                  class="testlet-card d-flex align-items-center justify-content-center rounded-8"
                  [ngClass]="testlet.cardClass"
                >
                  @if (testlet.progress === TestProgress.Current || testlet.progress === TestProgress.Completed) {
                    <div
                      class="position-relative"
                      [ngClass]="{
                        'd-flex align-items-center justify-content-center bg-white h-100 w-100 rounded-8':
                          testlet.progress === TestProgress.Completed,
                      }"
                    >
                      @if (testlet.progress === TestProgress.Completed) {
                        <div
                          class="position-absolute check-circle rounded-circle d-flex align-items-center justify-content-center"
                        >
                          <svg-icon
                            [svgStyle]="{
                              'width.px': 24,
                              'height.px': 24,
                              fill: '#fff',
                            }"
                            src="assets/icons/check.svg"
                          ></svg-icon>
                        </div>
                      }
                      <div class="text-center">
                        <svg-icon
                          class="svg-fill icon"
                          [src]="assessmentCards[testlet.testletType].icon"
                        ></svg-icon>
                        <div
                          class="testlet-label mt-2 mt-md-3 mt-lg-4 pt-lg-2"
                          [ngClass]="{
                            'text-white': testlet.progress === TestProgress.Current,
                          }"
                        >
                          {{ assessmentCards[testlet.testletType].label }}
                        </div>
                      </div>
                    </div>
                  }
                  @if (testlet.progress === TestProgress.NotCompleted) {
                    <svg-icon
                      class="svg-fill"
                      src="assets/icons/lock.svg"
                    ></svg-icon>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #action>
  <div class="action-button-block-sm-end-md">
    <app-button
      trackingId="assessment-overview"
      (clicked)="goToNextPage()"
    >
      Start {{ assessmentCards[nextTestletType].label | lowercase }}
    </app-button>
  </div>
</ng-template>
